module.exports = __webpack_public_path__ + "img/ls.fa89864d.svg";